
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import React from 'react';
import styles from '../../styles/home/introSection.module.scss';
export default function IntroSection() {
    return (<section className={styles.introSection}>
      <div className={styles.container}>
        <div className={styles.content}>
          <h2 className={styles.title}>
            HFDX integrates charting powered by TradingView, delivering a robust visual experience for market analysis.
          </h2>

          <div className={styles.description}>
            <p>
              TradingView is a widely used solution for traders and investors, accessible via web, desktop, and mobile devices.
            </p>
            <p>
              Through this integration, users can view live market pricing, Dow Futures, breaking financial news, in-depth market reports, and advanced analytical tools such as economic calendars and asset screeners.
            </p>
          </div>
        </div>
      </div>
    </section>);
}

    async function __Next_Translate__getStaticProps__1a17ab3f3c3__(ctx) {
      
      return {
        
        
        props: {
          
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: 'components//IntroSection',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__1a17ab3f3c3__ as getStaticProps }
  